export default {
    isGridOpen: state => state.gridIsOpen,
    isFormOpen: state => state.formIsOpen,
    isEhrFormOpen: state => state.ehrFormIsOpen,

    getTableAdditionalConfig: state => state.tableAdditionalConfig,
    getActions: state => state.actions,
    getReadOnlyActions: state => state.actionsReadOnly,
    getRowActions: state => state.rowActions,
    getReadOnlyRowActions: state => state.rowActionsReadOnly,
    getAdditionalExaminationPatientRowActions: state => state.additionalExaminationPatientRowActions,
    getPatientFields: state => state.patientFields,

    getAdditionalExaminationHeaderFields: state => state.additionalExaminationHeaderFields,
    getAdditionalExaminationPatientHeaderFields: state => state.additionalExaminationPatientHeaderFields,
}
